import React, { useState } from 'react';
import {
    Box,
    Typography,
    Container,
    Stack,
    Paper,
    Divider,
    Button,
    CircularProgress,
    List,
    ListItem,
    ListItemText,
    Chip,
    IconButton,
    Fab,
    Zoom,
    Card,
    CardContent,
    Grid,
    Menu, MenuItem
} from '@mui/material';
import {
    GroupAdd,
    HomeWork,
    Event,
    ChevronRight,
    Edit,
    Delete,
    Add,
    Description, // Icon for pending requests
    People, // Icon for groups
    Business, // Icon for properties
    MusicNote,
    MoreVert // Changed from SportsHandball to MusicNote for musical gigs/bolos
} from '@mui/icons-material';
import { useAuth } from '../auth/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import CreateGroupForm from './NewGroup';
import PropertyFormScreen from './NewProperty';
import { useNotification } from '../notification/NotificationProvider';

import ReceivedRequestDetail from './ReceivedRequestDetail';
import SVGComponentFooterEvents from './svgviewer-react-output-events-stream';
import SVGComponentFooterRockHand from './svgviewer-react-output-events';
import SVGComponentProperty from './svgviewer-react-output-property';
import SVGComponentSettings from './svgviewer-react-ouput-settings';
import SVGComponentTrash from './svgviewer-react-ouput-trash';

const ProfileAdminScreen = () => {
    const { dbUser, isLoading, refreshDbUser } = useAuth();
    const { triggerNotification } = useNotification();
    const navigate = useNavigate();
    const location = useLocation();

    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedGroup, setSelectedGroup] = useState(null);
    const [selectedReceivedRequest, setSelectedReceivedRequest] = useState(null);
    const [openFabMenu, setOpenFabMenu] = useState(false);

    // State for the three-point menu
    const [anchorEl, setAnchorEl] = useState(null);
    const [menuGroup, setMenuGroup] = useState(null); // To store the group for which the menu is open
    const open = Boolean(anchorEl);

    if (isLoading) {
        return (
            <Box sx={styles.centeredBox}>
                <CircularProgress sx={{ mr: 2 }} />
                <Typography variant="h5">Cargando datos de usuario...</Typography>
            </Box>
        );
    }

    if (!dbUser) {
        return (
            <Box sx={styles.centeredBox}>
                <Typography variant="h5" color="error">
                    Error: No se encontraron datos de usuario. Por favor, inicia sesión de nuevo.
                </Typography>
            </Box>
        );
    }
    //TODO: I dont know how to do this correctly
    // Listen for location state to kwow if update&not&reload is required
    // console.log('Checking location state...')
    // const { requiresUpdate } = location.state || {};
    // if (requiresUpdate) {
    //     location.state.requiresUpdate = false;
    //     console.log('Admin View Requires update')

    // }

    const handleGroupClick = () => {
        // setSelectedOption('group');
        // Unsupported so navigate
        setOpenFabMenu(false);
        // Clear the old state to let user create a BRAND NEW GROUP
        navigate('/misbolos/newgroup', { state: { editProps: null, editMode: false } })

    };

    const handlePropertyClick = () => {
        // setSelectedOption('property');
        setOpenFabMenu(false);
        navigate('/misbolos/newproperty')
    };
    const handlePropertyEditClick = (propertyName) => {
        // setSelectedOption('property');
        // setOpenFabMenu(false);
        //TODO: This screen is very ugly
        navigate(`/misbolos/property/${encodeURIComponent(propertyName)}`)
        // console.log('edit mode property redirect?')
        // console.log('Bellow there is a notification test...')
        triggerNotification({
            message: `Esta pantalla se encuentra en desarrollo`,
            sound: true,
            show: true,
            type: 'tiny-top',
            cat: 'received-request-from-group',
            isError: true,
            forceId: 'not-possible-to-interact-with-a-property-from-admin-panel'
        });
    };
    const handleActivityClick = () => {
        // setSelectedOption('activity');
        setOpenFabMenu(false);
        navigate('/misbolos/newbolo')
    };

    const handleAcceptInvitation = async (request) => {
        try {
            const requestId = request._id;
            console.log(`Accepting request with ID: ${requestId}`);

            if (request.type == 'group-to-join-activity') {
                console.log('Accept request from an activity to a group (owner)')
                await dbUser.acceptJoinActivityReceivedRequest(requestId)

            } else if (request.type == 'user-to-join-group') {
                console.log('Accept request from a group to a user')
                await dbUser.acceptReceivedRequest(requestId);
            } else {
                console.log('REQUEST.TYPE not recognized, this should not happen')
                console.log('Request:', request)
            }

            setSelectedOption(null);
            setSelectedReceivedRequest(null);
            triggerNotification({
                message: `Bienvenido al grupo <grupoNombre????> `,
                sound: true,
                show: true,
                type: 'tiny-top',
                cat: 'received-request-from-group',
                forceId: 'admin-panel-handle-accept-invitation-success'
            });
            console.warn('Refreshing dbUser is not available yet')
            // await refreshDbUser();
        } catch (error) {
            console.error('Error accepting invitation:', error);
            triggerNotification({
                message: 'Error al aceptar la invitación.',
                show: true,
                type: 'tiny-top',
                cat: 'error',
                isError: true,
                forceId: 'admin-panel-handle-accept-invitation-error'
            });
        }
        await dbUser.update();
    };

    const handleDenyInvitation = async (request) => {
        const requestId = request._id
        try {
            console.log(`Denying request with ID: ${requestId}`);
            if (request.type == 'group-to-join-activity') {
                console.log('Deny request from an activity to a group (owner)')
                await dbUser.denyJoinActivityReceivedRequest(requestId)

            } else if (request.type == 'user-to-join-group') {
                console.log('Deny request from a group to a user')
                await dbUser.denyReceivedRequest(requestId);
            } else {
                console.log('REQUEST.TYPE not recognized, this should not happen')
                console.log('Request:', request)
            }
            setSelectedOption(null);
            setSelectedReceivedRequest(null);
            triggerNotification({
                message: 'Invitación para unirte al grupo <groupName????> rechazada 😅',
                sound: true,
                show: true,
                type: 'tiny-top',
                cat: 'received-request-from-group',
                forceId: 'admin-panel-handle-deny-invitation-success'
            });
            // await refreshDbUser();
            window.location.reload(); // Force reload to reflect changes
        } catch (error) {
            console.error('Error denying invitation:', error);
            triggerNotification({
                message: 'Error al rechazar la invitación.',
                show: true,
                type: 'tiny-top',
                cat: 'error',
                isError: true,
                forceId: 'admin-panel-handle-deny-invitation-error'
            });
        }
    };


    const handleMenuClick = (event, group) => {
        event.stopPropagation(); // Prevent ListItem click
        setAnchorEl(event.currentTarget);
        setMenuGroup(group);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setMenuGroup(null);
    };

    const handleEditGroup = (e) => {
        e.stopPropagation()
        if (menuGroup) {
            setSelectedGroup(menuGroup);
            navigate('/misbolos/newgroup', {
                state: { editProps: menuGroup, editMode: true },
            });
        }
        handleMenuClose();
    };

    const handleDeleteGroup = async (e) => {
        e.stopPropagation()
        const realresponse = await dbUser.deleteGroup(menuGroup._id)
        // console.log('RealResponse', realresponse)
        // console.log('old dbUser', dbUser)
        const something = await dbUser.update()
        // console.log('updated dbUser (same as old)', dbUser)
        // console.log('something (real updated)', something)
        // if (menuGroup) {
        //     console.log(`Deleting group: ${menuGroup.name}`);
        //     // Implement your delete logic here
        //     // e.g., call an API to delete the group
        // }
        //TODO: Add option type name of the group to delete it
        triggerNotification({
            message: `Has borrado el grupo ${menuGroup.name} 😶‍🌫️`,
            sound: true,
            show: true,
            type: 'tiny-top',
            cat: 'received-request-from-group',
            forceId: 'admin-panel-handle-delete-group-success'
        });
        handleMenuClose();
    };


    const renderContent = () => {
        // Get current date and time for comparison
        const now = new Date();

        switch (selectedOption) {
            case 'group':
                return (
                    <Typography>This is no longer supported, must redirect</Typography>
                    //   <CreateGroupForm
                    //     editMode={false}
                    //     editProps={selectedGroup}
                    //     onCancel={() => setSelectedOption(null)}
                    //   />
                );
            // navigate('/misbolos/creategroup')

            case 'editGroup':
                return (
                    <CreateGroupForm
                        editMode={true}
                        editProps={selectedGroup}
                        onCancel={() => {
                            setSelectedGroup(null);
                            setSelectedOption(null);
                        }}
                    />
                );

            case 'property':
                return <PropertyFormScreen onCancel={() => setSelectedOption(null)} />;

            case 'activity':
                return (
                    <Typography variant="h6">
                        La pantalla de gestión de actividades estará disponible pronto.
                        <Button onClick={() => setSelectedOption(null)} sx={{ mt: 2 }} variant="outlined">Volver</Button>
                    </Typography>
                );

            case 'receivedRequest':
                return (
                    <ReceivedRequestDetail
                        request={selectedReceivedRequest}
                        onAccept={handleAcceptInvitation}
                        onDeny={handleDenyInvitation}
                        onBack={() => {
                            setSelectedReceivedRequest(null);
                            setSelectedOption(null);
                        }}
                        styles={styles}
                    />
                );

            default:
                return (
                    <Stack spacing={4} alignItems="center" textAlign="center">
                        <Typography variant="h4" fontWeight="bold" sx={{ color: 'black', fontSize: '1.9rem' }}>
                            Panel De Control
                        </Typography>

                        <Typography variant="h6" color="text.secondary" sx={{ fontSize: '0.9rem' }}>
                            Gestiona tus grupos y bolos musicales, y obtén la web gratuita para tu banda.
                        </Typography>

                        <Divider sx={{ width: '80%', my: 4 }} />

                        <Box sx={{ width: '100%', maxWidth: 800, textAlign: 'left', px: { xs: 2, sm: 0 } }}>
                            <Typography variant="h5" fontWeight="bold" sx={{ mb: 2, color: '#424242' }}>
                                Estado Actual
                            </Typography>

                            {/* Your Group Requests */}
                            <Card sx={styles.infoCard}>
                                <CardContent>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                        <Description color="primary" />
                                        <Typography variant="h6" fontWeight="bold">
                                            {/* Invitaciones Recibidas ({dbUser.misbolos?.receivedRequests?.length || 0}) */}
                                            Invitaciones Recibidas ({
                                                (dbUser.misbolos?.receivedRequests?.length || 0) +
                                                (dbUser.misbolos?.groups?.reduce((acc, group) => acc + (group.receivedRequests?.length || 0), 0) || 0)
                                            })

                                        </Typography>
                                    </Stack>
                                    {(dbUser.misbolos?.receivedRequests?.length > 0 ||
                                        dbUser.misbolos?.groups?.some(group => group.receivedRequests?.length > 0)) ? (
                                        <List disablePadding>
                                            {[
                                                ...(dbUser.misbolos?.receivedRequests || []),
                                                ...(
                                                    dbUser.misbolos?.groups?.filter(g => g.owner == dbUser._id).flatMap(group =>
                                                        group.receivedRequests || []
                                                    ) || []
                                                )
                                            ].map(rr => (
                                                <ListItem
                                                    key={`lirrid-${rr._id}`}
                                                    secondaryAction={
                                                        <IconButton
                                                            edge="end"
                                                            aria-label="view-details"
                                                            onClick={() => {
                                                                setSelectedReceivedRequest(rr);
                                                                setSelectedOption('receivedRequest');
                                                            }}
                                                        >
                                                            <ChevronRight />
                                                        </IconButton>
                                                    }
                                                    sx={styles.listItemStyled}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body1" component="span" fontWeight="medium">
                                                                {rr.groupName || rr.activityTitle}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Typography variant="body2" component="span" color="text.secondary" noWrap>
                                                                De: {rr.senderName || 'Un bolo en tu zona'}
                                                            </Typography>
                                                        }
                                                    />

                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography color="text.secondary" sx={{ ml: 2, mb: 1 }}>
                                            No tienes invitaciones recibidas aún.
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>

                            {/* Groups */}
                            <Card sx={styles.infoCard}>
                                <CardContent>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                        <People color="secondary" />
                                        <Typography variant="h6" fontWeight="bold">
                                            Tus Grupos ({dbUser.misbolos?.groups?.length || 0})
                                        </Typography>
                                    </Stack>
                                    {dbUser.misbolos?.groups?.length > 0 ? (
                                        <List disablePadding>
                                            {dbUser.misbolos.groups.map(group => (
                                                <ListItem
                                                    key={`groupId-${group._id}`}
                                                    onClick={() => { navigate(`/misbolos/groups/${group.name}`) }}
                                                    secondaryAction={
                                                        dbUser._id === group.owner && (
                                                            <>
                                                                <IconButton
                                                                    edge="end"
                                                                    aria-label="group-menu"
                                                                    onClick={(e) => handleMenuClick(e, group)}
                                                                >
                                                                    <MoreVert />
                                                                </IconButton>
                                                                <Menu
                                                                    id="group-menu"
                                                                    anchorEl={anchorEl}
                                                                    open={open && menuGroup?._id === group._id}
                                                                    onClose={handleMenuClose}
                                                                    MenuListProps={{
                                                                        'aria-labelledby': 'group-menu-button',
                                                                    }}
                                                                >
                                                                    <MenuItem onClick={handleEditGroup}>
                                                                        <SVGComponentSettings width={24} height={24} style={{ marginRight: 8 }} />  Gestionar
                                                                    </MenuItem>
                                                                    <MenuItem onClick={handleDeleteGroup}>
                                                                        <SVGComponentTrash width={24} height={24} style={{ marginRight: 8 }} />  Eliminar
                                                                    </MenuItem>
                                                                </Menu>
                                                            </>
                                                        )
                                                    }
                                                    sx={styles.listItemStyled}
                                                >
                                                    <ListItemText
                                                        primary={
                                                            <Typography variant="body1" component="span" fontWeight="medium">
                                                                {group.name}
                                                            </Typography>
                                                        }
                                                        secondary={
                                                            <Stack direction="column" spacing={0.5} mt={0.5}>
                                                                <Typography variant="body2" color="text.secondary" component="span">
                                                                    Miembros: {group.members.length}
                                                                </Typography>

                                                                {group.pendingMembers.length > 0 && (
                                                                    <Chip
                                                                        label={`Pendientes: ${group.pendingMembers.length}`}
                                                                        size="small"
                                                                        sx={{
                                                                            height: 20,
                                                                            alignSelf: 'start',
                                                                            backgroundColor: '#482b8c',
                                                                            color: '#fff',
                                                                        }}
                                                                    />
                                                                )}

                                                                <Chip
                                                                    label={dbUser._id === group.owner ? 'Administrador' : 'Miembro'}
                                                                    size="small"
                                                                    sx={{
                                                                        height: 20,
                                                                        alignSelf: 'start',
                                                                        backgroundColor: dbUser._id === group.owner ? '#1c274c' : '#785af0',
                                                                        color: '#fff',
                                                                    }}
                                                                />
                                                            </Stack>
                                                        }
                                                        slotProps={{
                                                            secondary: {
                                                                component: 'div',
                                                            },
                                                        }}
                                                    />



                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography color="text.secondary" sx={{ ml: 2, mb: 1 }} component="span">
                                            No tienes ningún grupo aún.
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>

                            {/* Properties */}
                            <Card sx={styles.infoCard}>
                                <CardContent>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                        <Business color="info" />
                                        <Typography variant="h6" fontWeight="bold" component="span">
                                            Tus Propiedades ({Object.keys(dbUser.misbolos?.properties || {}).length})
                                        </Typography>
                                    </Stack>
                                    {dbUser.misbolos?.properties && Object.keys(dbUser.misbolos.properties).length > 0 ? (
                                        <List disablePadding>
                                            {Object.values(dbUser.misbolos.properties).map(property => (
                                                <ListItem key={property.name} sx={styles.listItemStyled} onClick={() => { handlePropertyEditClick(property.name) }}>
                                                    <ListItemText
                                                        primary={
                                                            <Typography
                                                                component="span" // ← THIS FIXES IT
                                                                variant="body1"
                                                                fontWeight="medium"
                                                                noWrap
                                                            >
                                                                {property.name}
                                                            </Typography>
                                                        }
                                                    />

                                                </ListItem>
                                            ))}
                                        </List>
                                    ) : (
                                        <Typography color="text.secondary" sx={{ ml: 2, mb: 1 }}>
                                            No has añadido ninguna propiedad aún.
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>

                            {/* Activities */}
                            <Card sx={styles.infoCard}>
                                <CardContent>
                                    <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
                                        <MusicNote color="warning" /> {/* Icono de nota musical para "Bolos Pendientes" */}
                                        <Typography variant="h6" fontWeight="bold">
                                            Tus Bolos ({dbUser.misbolos?.activities?.length || 0})
                                        </Typography>
                                    </Stack>
                                    {dbUser.misbolos?.activities?.length > 0 ? (
                                        <List disablePadding>
                                            {dbUser.misbolos.activities.map(activity => {
                                                const activityDate = new Date(activity.date);
                                                const isPastDue = activityDate < now; // Check if the activity date is in the past

                                                return (
                                                    <ListItem
                                                        key={`activityId-${activity._id}-${activity.title}`}
                                                        sx={{
                                                            ...styles.listItemStyled,
                                                            opacity: isPastDue ? 0.6 : 1, // Reduce opacity for past due activities
                                                            backgroundColor: isPastDue ? '#f5f5f5' : styles.listItemStyled.backgroundColor, // Subtle background for past due
                                                            cursor: isPastDue ? 'not-allowed' : 'pointer', // Change cursor for past due
                                                        }}
                                                        onClick={() => { navigate(`/misbolos/activities/${activity.title}`) }}
                                                        disabled={isPastDue} // Disable the ListItem component
                                                    >
                                                        <ListItemText
                                                            primary={
                                                                <Typography
                                                                    variant="body1"
                                                                    component="span"
                                                                    fontWeight="medium"
                                                                    noWrap
                                                                    sx={{
                                                                        textDecoration: isPastDue ? 'line-through' : 'none', // Strikethrough for past due
                                                                        color: isPastDue ? 'text.disabled' : 'inherit', // Grey out text for past due
                                                                    }}
                                                                >
                                                                    {activity.title}
                                                                </Typography>
                                                            }
                                                            secondary={
                                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                                    <Typography
                                                                        variant="body2"
                                                                        color={isPastDue ? 'text.disabled' : 'text.secondary'}
                                                                        component="span"
                                                                    >
                                                                        {`Fecha: ${activityDate.toLocaleDateString()}`}
                                                                    </Typography>
                                                                    <Chip
                                                                        label={isPastDue ? 'Finalizado' : 'Pendiente'}
                                                                        size="small"
                                                                        color={isPastDue ? 'default' : 'warning'}
                                                                        sx={{
                                                                            height: 20,
                                                                            fontSize: '0.7rem',
                                                                            fontWeight: 'bold',
                                                                        }}
                                                                    />
                                                                </Stack>
                                                            }
                                                            slotProps={{
                                                                secondary: {
                                                                    component: 'div',
                                                                },
                                                            }}
                                                        />
                                                    </ListItem>
                                                );
                                            })}
                                        </List>
                                    ) : (
                                        <Typography color="text.secondary" sx={{ ml: 2, mb: 1 }}>
                                            No estás relacionado con ningún bolo musical aún.
                                        </Typography>
                                    )}
                                </CardContent>
                            </Card>
                        </Box>
                    </Stack>
                );
        }
    };

    return (
        <Box sx={styles.screenContainer}>
            <Container maxWidth="md">
                {renderContent()}
            </Container>

            {/* Floating Action Buttons */}
            {selectedOption === null && (
                <Box
                    sx={{
                        position: 'fixed',
                        bottom: 68,
                        right: 16,
                        display: 'flex',
                        flexDirection: 'column-reverse',
                        alignItems: 'flex-end',
                        gap: 1.5,
                        zIndex: 1000,
                    }}
                >
                    {openFabMenu && (
                        <Zoom in={openFabMenu} timeout={300}>
                            <Stack spacing={1.5} direction="column-reverse">
                                <Fab
                                    variant="extended"
                                    color="secondary"
                                    aria-label="crear actividad"
                                    onClick={handleActivityClick}
                                    sx={styles.extendedFab}
                                >
                                    <SVGComponentFooterEvents sx={{ mr: 1 }} width={24} height={24} />
                                    Actividad
                                </Fab>
                                <Fab
                                    variant="extended"
                                    color="secondary"
                                    aria-label="añadir propiedad"
                                    onClick={handlePropertyClick}
                                    sx={styles.extendedFab}
                                >
                                    <SVGComponentProperty sx={{ mr: 1 }} width={28} height={28} />
                                    Propiedad
                                </Fab>
                                <Fab
                                    variant="extended"
                                    color="secondary"
                                    aria-label="crear grupo"
                                    onClick={handleGroupClick}
                                    sx={styles.extendedFab}
                                >
                                    <SVGComponentFooterRockHand sx={{ mr: 1 }} width={32} height={32} />
                                    Grupo
                                </Fab>
                            </Stack>
                        </Zoom>
                    )}

                    <Fab
                        color="primary"
                        aria-label="add"
                        onClick={() => setOpenFabMenu(!openFabMenu)}
                        sx={styles.mainFab}
                    >
                        <Add />
                    </Fab>
                </Box>
            )}
        </Box>
    );
};

const styles = {
    screenContainer: {
        minHeight: '100vh',
        // //background: 'linear-gradient(to bottom right, #e3f2fd, #bbdefb)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: { xs: 1, sm: 2, md: 3 },
        position: 'relative',
    },
    centeredBox: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
    },
    infoCard: {
        mb: 3,
        borderRadius: 3,
        boxShadow: '0 6px 20px rgba(0,0,0,0.08)',
        transition: 'transform 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-5px)',
        },
        backgroundColor: '#ffffff',
        border: '1px solid #e0e0e0',
    },
    listItemStyled: {
        borderBottom: '1px solid #f0f0f0',
        '&:last-child': {
            borderBottom: 'none',
        },
        '&:hover': {
            backgroundColor: '#f5f5f5',
        },
        py: 1.5,
    },
    detailCard: {
        padding: 4,
        borderRadius: 2,
        backgroundColor: '#ffffff',
        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
        textAlign: 'center',
        maxWidth: 500,
        margin: 'auto',
    },
    mainFab: {
        color: 'black',
        backgroundColor: 'white',
        '&:hover': {
            // backgroundColor: '#9C27B0',
            backgroundColor: '#d9d9d9'
        },
        width: 56,
        height: 56,
    },
    extendedFab: {
        backgroundColor: 'white',
        color: 'black',
        '&:hover': {
            backgroundColor: '#d9d9d9',
        },
        boxShadow: '0 3px 6px rgba(0,0,0,0.16)',
        textTransform: 'none',
        fontWeight: 'bold',
        minWidth: 140,
    },
};

export default ProfileAdminScreen;